import type { UsersAction } from './actions';
import { UsersActionTypes } from './actionTypes';

import type { AccessibleFleet, User } from '@cobliteam/common-types';

import { type UserAttributes, type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';

export interface UsersState {
  loadUsersWebData: WebData<User[]>;
  deleteUserWebData: WebData<void>;
  saveUserWebData: WebData<void>;
  userAttributesWebData: WebData<UserAttributes>;
  accessibleFleetsWebData: WebData<AccessibleFleet[]>;
}

export const usersInitialState: UsersState = {
  loadUsersWebData: webDataNotAsked(),
  deleteUserWebData: webDataNotAsked(),
  saveUserWebData: webDataNotAsked(),
  userAttributesWebData: webDataNotAsked(),
  accessibleFleetsWebData: webDataNotAsked(),
};

export const usersReducer = (state: UsersState = usersInitialState, action: UsersAction): UsersState => {
  switch (action.type) {
    case UsersActionTypes.LOAD_USERS_REQUEST:
      return {
        ...state,
        loadUsersWebData: webDataFetching(),
      };

    case UsersActionTypes.LOAD_USERS_SUCCEEDED:
      return {
        ...state,
        loadUsersWebData: webDataSuccess(action.payload),
      };

    case UsersActionTypes.LOAD_USERS_FAILED:
      return {
        ...state,
        loadUsersWebData: webDataError(),
      };

    case UsersActionTypes.DELETE_USER_REQUEST:
      return {
        ...state,
        deleteUserWebData: webDataFetching(),
      };

    case UsersActionTypes.DELETE_USER_SUCCEEDED:
      return {
        ...state,
        deleteUserWebData: webDataSuccess(undefined),
      };

    case UsersActionTypes.DELETE_USER_FAILED:
      return {
        ...state,
        deleteUserWebData: webDataError(),
      };

    case UsersActionTypes.LOAD_USER_ATTRIBUTES_REQUEST:
      return {
        ...state,
        userAttributesWebData: webDataFetching(),
      };

    case UsersActionTypes.LOAD_USER_ATTRIBUTES_SUCCEEDED:
      return {
        ...state,
        userAttributesWebData: webDataSuccess(action.payload),
      };

    case UsersActionTypes.LOAD_USER_ATTRIBUTES_FAILED:
      return {
        ...state,
        userAttributesWebData: webDataError(),
      };

    case UsersActionTypes.LOAD_ACCESSIBLE_FLEETS_SUCCEEDED:
      return {
        ...state,
        accessibleFleetsWebData: webDataSuccess(action.payload),
      };

    case UsersActionTypes.LOAD_ACCESSIBLE_FLEETS_REQUEST:
      return {
        ...state,
        accessibleFleetsWebData: webDataFetching(),
      };

    case UsersActionTypes.LOAD_ACCESSIBLE_FLEETS_FAILED:
      return {
        ...state,
        accessibleFleetsWebData: webDataError(),
      };

    default:
      return state;
  }
};
